import { FC, memo } from 'react';
import { BiDotsVertical } from 'react-icons/bi';
import { HStack, IconButton } from '@chakra-ui/react';

import { Menu } from '~/core/shared/components/Menu';
import { EditDetails } from '../EditDetails';
import { EditDetailsMenuProps } from './types/EditDetailsMenuProps';
import { EntityControlMenuItem } from './EntityControlMenuItem';

const EditDetailsMenuComponent: FC<EditDetailsMenuProps> = ({
  blockId,
  documentType,
  title,
  controls,
  onOpenConfirm,
  handleSideEffects,
}) => {
  if (!controls.length) {
    return (
      <EditDetails
        blockId={blockId}
        documentType={documentType}
        title={title}
      />
    );
  }

  return (
    <HStack gap={2}>
      <EditDetails
        blockId={blockId}
        documentType={documentType}
        title={title}
      />
      <Menu
        menuContent={controls.map((control, index) => (
          <EntityControlMenuItem
            key={control.name}
            control={control}
            documentId={blockId}
            handleSideEffects={(sideEffects) =>
              handleSideEffects(index, sideEffects)
            }
            onOpenConfirm={onOpenConfirm}
          />
        ))}
      >
        <IconButton
          border="none"
          color="black"
          lineHeight={0}
          variant="outline"
        >
          <BiDotsVertical />
        </IconButton>
      </Menu>
    </HStack>
  );
};

export const EditDetailsMenu = memo(EditDetailsMenuComponent);
